import { Button } from '@mui/material';
import { CloudDownload } from '@mui/icons-material';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { EventParticipant } from '../models/eventParticipant';

type EventDetailExportParticipantButtonProps = {
  participants: EventParticipant[];
};

export const EventDetailExportParticipantButton = (props: EventDetailExportParticipantButtonProps) => {
  const { participants } = props;

  const { t } = useTranslation(['event']);

  const handleExport = () => {
    // Array of object proprties that we dont want to export
    const removeColumns = ['id', 'event_id', 'member_id', 'createdById', 'createdByName', 'guid', 'invoiceId', 'invoiceGuid'];

    const cleanedData = participants.map((item) => {
      const newItem = { ...item };
      removeColumns.forEach((key) => delete newItem[key]);
      return newItem;
    });

    const items = cleanedData;
    const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here
    const header = Object.keys(items[0]);
    const csv = [
      header.map((field) => t(`invoice:exportParticipants.${field}`)).join(','), // header row first
      ...items.map((row) => header.map((fieldName) => JSON.stringify(row[fieldName], replacer)).join(',')),
    ].join('\r\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const fileName = `eventdeltagare_(${items.length})_${dayjs(new Date()).format('YYYYMMDD_HHmm')}.csv`;
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success(<>{t('invoice:export.exportSuccess')}</>);
    }
  };

  return (
    <Button
      size='small'
      variant='outlined'
      endIcon={<CloudDownload fontSize='small' />}
      onClick={() => {
        handleExport();
      }}
    >
      {t('common:button.export')}
    </Button>
  );
};
